export enum RoutePath {
  Index = '/index.html',
  Home = '/',
  Projects = '/projects',
  About = '/about',
  Contact = '/contact'
}
